import { createRouter, createWebHistory } from 'vue-router';
import { i18n } from './main.js'; // Import the i18n instance
import { routeGuard, startDatePT, endDatePT } from './routeGuards';

import HomePageV1 from './Pages/Home/HomePageV1.vue';
import HomePageV2 from './Pages/Home/HomePageV2.vue';
import SignIn from './Pages/Sign-In/Signin';
import FAQ from './Pages/FAQ/FAQ.vue';
import PreProgram from './Pages/Home/Homepagecomponents/PreProgram.vue';
import PostProgram from './Pages/Home/Homepagecomponents/PostProgram.vue';
import QR from './Pages/QR/QR.vue';

const routes = [
  {
    path: '/',
    redirect: '/Home-V1',
  },
  {
    path: '/Home',
    redirect: '/Home-V1',
  },
  {
    path: '/Home-V1',
    name: 'HomeV1',
    component: HomePageV1,
    meta: { titleKey: 'HomeV1' },
    props: { startDate: startDatePT, endDate: endDatePT },
  },
  {
    path: '/Home-V2',
    name: 'HomeV2',
    component: HomePageV2,
    meta: { titleKey: 'HomeV2' },
    props: { startDate: startDatePT, endDate: endDatePT },
  },
  {
    path: '/SignIn',
    name: 'SignIn',
    component: SignIn,
    meta: { titleKey: 'SignIn' },
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    component: FAQ,
    meta: { titleKey: 'FAQ' },
  },
  {
    path: '/QR',
    name: 'QR',
    component: QR,
    meta: { titleKey: 'QR' }, // Use titleKey to reference the title
  },
  {
    path: '/PreProgram',
    name: 'PreProgram',
    component: PreProgram,
    meta: { titleKey: 'PreProgram', hideNav: true },
    props: { startDate: startDatePT },
  },
  {
    path: '/PostProgram',
    name: 'PostProgram',
    component: PostProgram,
    meta: { titleKey: 'PostProgram', hideNav: true },
    props: { endDate: endDatePT },
  },
  { path: '/:notFound(.*)', redirect: '/Home' },
];

// Create the router
const router = createRouter({
  linkActiveClass: 'active',
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Dynamically set page title based on route
router.beforeEach((to, from, next) => {

  const pageTitleKey = to.meta.titleKey; // Access the title key
  if (pageTitleKey) {
    const translatedTitle = i18n.global.t(`titles.${pageTitleKey}`); // Fetch translated title using i18n
    document.title = translatedTitle || 'Default Title'; // Set the page title dynamically
  }
  next();
});

router.beforeEach(routeGuard);

export default router;
